var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":true},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('list-package',{attrs:{"listPackage":_vm.listPackage},on:{"eventCheckAll":function($event){return _vm.onCheckAll($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }